<template>
  <v-autocomplete
    v-if="filter !== undefined"
    v-model="valueData"
    variant="outlined"
    clearable
    :disabled="$loader.loading"
    :append-inner-icon="filter.icon"
    :label="filter.label"
    :items="filter.items"
    hide-details
    :density="dense"
    color="orange lighten-2"
    @change="onInput"
    @update:model-value="(v: any) => filter.onUpdate && filter.onUpdate(v)"
  />
</template>

<script lang="ts">
import { type PropType, defineComponent } from 'vue'

import type DensityProp from '@/types/vuetify/Density'

export default defineComponent({
  props: {
    value: {
      type: String,
      default: '',
    },
    filter: {
      required: true,
      type: Object,
    },
    dense: {
      type: String as PropType<DensityProp>,
      default: 'default',
    },
  },
  emits: [ 'input' ],
  data() {
    return {
      valueData: this.value,
    }
  },
  methods: {
    onInput(): void {
      if (this.valueData != null) {
        this.$emit('input', this.valueData)
      } else {
        this.$emit('input', '')
      }
    },
  },
})
</script>
